import { RadiusOutlineIcon } from './RadiusOutlineIcon';

/**
 * author: Michael Richins
 * id 51C82800-F946-45C3-A88B-B5D52BD6B80B
 * name radius-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/radius-outline.svg
 * tags
 * - Math 
 */
export const SphereRadiusOutlineIcon = RadiusOutlineIcon;
export default SphereRadiusOutlineIcon